import React from 'react'
import Icofont from 'react-icofont'
import {
  Button,
  Row,
  Col,
  Form,
  InputGroup,
  Card,
  Image,
  Spinner
} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
// import { loadPolizasByIdentificacion } from 'src/reducer/action/poliza';
import { useNavigate } from 'react-router-dom'
import { submitIdentificacionToURLAcceso } from 'src/reducer/action/auth'
import { useForm } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'

// img
import credito from 'src/assets/tcredito.webp'
import clave from 'src/assets/clave.webp'
import yappy from 'src/assets/yappy.png'
import { AlertCommon } from 'src/common/AlertCommon'
import { useMediaQuery } from 'react-responsive'


export const PagoSinID = () => {
  const dispatch = useDispatch()
  let navigate = useNavigate()
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const { loadingURLAcceso } = useSelector(state => state.auth)

  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm()

  const handleSubmitForm = data => {
    const { identificacion } = data
    dispatch(submitIdentificacionToURLAcceso(identificacion, navigate))
  }

  return (
    <React.Fragment>
      <Row className='justify-content-center pt-5'>
        <Col md={5}>
          <Card
            className='shadow border-0 p-4 text-center border-rounded card-tarjeta-responsive'
            style={{ borderRadius: '15px' }}
          >
            <Card.Body>
              <Form onSubmit={handleSubmit(handleSubmitForm)}>
                <AlertCommon />
                <h1 className='text-center' style={{
                  color: '#2A1AB9',
                  fontSize: isMobile ? '27px' : '35px',
                  fontWeight: 'bold'
                }}>Pague en línea</h1>
                <p className='form-text'>Métodos de pago:</p>
                <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                  <Image src={credito} alt="tarjeta de credito" width={90} fluid />
                  <Image src={yappy} alt="yappy" width={100} fluid />
                  <Image src={clave} alt="clave" width={80} fluid />
                </div>
                <br />
                <br />
                <InputGroup>
                  <input
                    type='text'
                    placeholder='Ingrese su cedula, pasaporte o RUC'
                    className={`form-control form-control-md ${errors.identificacion
                      ? 'border-2 border-bottom-danger'
                      : ''
                      } border border-2`}
                    {...register('identificacion', {
                      required: 'Es requerido'
                    })}
                  />
                </InputGroup>
                {/* <ErrorMes */}
                {/* {errors.identificacion && <p>{errors.identificacion.message}</p>} */}
                <ErrorMessage
                  errors={errors}
                  name='singleErrorInput'
                  render={({ message }) => <p>{message}</p>}
                />
                <br />
                <div className='text-center'>
                  <button
                    type='submit'
                    className='btn-pay btn-pay-xs'
                    disabled={loadingURLAcceso}
                  >
                    {loadingURLAcceso ? (
                      <div className='text-center'>
                        <Spinner animation='grow' variant='light' size='sm' />
                      </div>
                    ) : (
                      'Iniciar'
                    )}
                  </button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
        {/* <Col md={7} xs={12}>
          <div className='text-center canales-pago'>
          <h5
          className='fw-bold'
          style={{
            letterSpacing: '1.3px'
          }}
          >
          Canales de pagos
          </h5>
        <div style={{ display: 'grid', gridTemplateColumns: '100%' }}> */}
        {/* <div>
                                <Image
                                    src={credito}
                                    alt='tarjeta de credito'
                                    width={220}
                                    fluid
                                    />
                                  </div> */}
        {/* <div> */}
        {/* <p className='form-text p-0 m-0'>Yappy</p> */}
        {/* <Image src={yappy} alt='tarjeta de credito' width={100} fluid /> */}
        {/* </div>
            </div>
          </div> */}
        {/* </Col> */}
      </Row>
    </React.Fragment>
  )
}
